// Asset cost rollup: cumulative maintenance cost for an asset (and its descendants) over a period.

export const FETCH_ASSET_COST = 'FETCH_ASSET_COST';
export const FETCH_ASSET_COST_SUCCESS = 'FETCH_ASSET_COST_SUCCESS';
export const FETCH_ASSET_COST_FAIL = 'FETCH_ASSET_COST_FAIL';
export const CLEAR_ASSET_COST = 'CLEAR_ASSET_COST';
